import { assign, get } from 'lodash';
import { Injectable } from '@angular/core';

@Injectable()
export class FriendlyNamesService {
  private friendlyNames: Object = {};

  getFriendlyName(): string {
    return get(this.friendlyNames, 'key', null);
  }

  addNames(names: Object): void {
    assign(this.friendlyNames, names);
  }

  getName(key: string): string {
    // returns friendly name. if name does not exists, returns key instead.
    return get(this.friendlyNames, key, key);
  }
}
